<template>
  <div id="app">
    <div class="bg">
      <video-player  class="video-player vjs-custom-skin "
                     ref="videoPlayer"
                     :playsinline="true"
                     :options="playerOptions"
                     @statechanged="playerStateChanged($event)"
      >
      </video-player>
    </div>


    <div class="content" v-show="isShow">
      <h2 class="content-h2 animated wobble slower">welcome to login</h2>

      <div class="content-textfield animated shake">
        <div class="content-textfield-one">
          <div class="content-textfield-i">需要验证您的口令哦, (*^__^*)</div>
          <van-field class="content-textfield-field" v-model="phone"
                     type="tel"
                     left-icon="gift-card-o" required placeholder="请输入口令"
                     maxlength="11" clearable @input="fieldInput">

          </van-field>
        </div>

        <div class="content-textfield-two">
          <div class="content-textfield-i">可否告知你的昵称呢(选填)</div>
          <van-field class="content-textfield-field" v-model="nickName"
                     left-icon="smile-o" placeholder="请输入昵称"
                     maxlength="11" clearable>

          </van-field>
        </div>
      </div>

      <div class="content-commit">
        <van-button class="content-commit-btn" type="info" round plain
                    loading-text="加载中..." @click="clickCommitBtn"
                    :disabled=isDisableClick
        >登录
        </van-button>

      </div>
    </div>
    <van-dialog v-model="isShowDialog" title="登录成功"
                :show-confirm-button="isShowOKBtn">
    </van-dialog>
    <van-loading class="loading" v-show="isShowLoading" color="#1989fa" size="54px"/>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import 'video.js/dist/video-js.css';
// eslint-disable-next-line no-unused-vars
import { videoPlayer } from 'vue-video-player';

export default {
  name: 'app',
  data() {
    return {
      phone: '',
      nickName: '',
      isShow: false,
      isDisableClick: true,
      loginId: '',
      isShowDialog: false,
      isShowOKBtn: false,
      isShowLoading: false,
      srcList: ['http://h5.howiech.com/assets/bg0.mp4',
        'http://h5.howiech.com/assets/bg1.mp4',
        'http://h5.howiech.com/assets/bg2.mp4',
        'http://h5.howiech.com/assets/bg3.mp4',
        'http://h5.howiech.com/assets/bg4.mp4'],
      srcIndex: 0,
      playerOptions: {
        autoplay: false,
        muted: true,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        sources: [{
          type: 'video/mp4',
          src: 'http://h5.howiech.com/assets/bg0.mp4',
        }],
        poster: 'http://h5.howiech.com/assets/poster.jpg',
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight,
        controls: false,
      },
    };
  },
  mounted() {
    // eslint-disable-next-line no-restricted-globals
    // console.log(process.env.NODE_ENV);
    // console.log(process.env.VUE_APP_API);
    document.addEventListener('WeixinJSBridgeReady', () => { this.$refs.videoPlayer.player.play(); }, false);
    // eslint-disable-next-line no-underscore-dangle,no-empty
    if (!this._isMobile()) {
      this.$refs.videoPlayer.player.src('http://h5.howiech.com/assets/pc0.mp4');
      this.$refs.videoPlayer.player.play();
    }
    // eslint-disable-next-line no-underscore-dangle
    if (this._isIOS()) {
      this.$refs.videoPlayer.player.play();
    }

    this.loginId = this.getUrlKey('loginId');
    setInterval(() => {
      this.isShow = true;
    }, 3000);
  },
  methods: {
    getUrlKey(name) {
      // eslint-disable-next-line no-useless-concat,no-restricted-globals,no-sparse-arrays
      return decodeURIComponent((new RegExp(`[?|&]${name}=` + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
    },

    // eslint-disable-next-line no-param-reassign
    fieldInput(v) {
      // eslint-disable-next-line no-param-reassign
      v = `${v}`;
      // eslint-disable-next-line eqeqeq
      this.isDisableClick = v.length < 8;
    },

    async clickCommitBtn() {
      this.isShowLoading = true;
      if (this.loginId == null) {
        this.isShowLoading = false;
        this.$dialog.alert({
          message: '配置错误, 请重新扫描',
        });
        return;
      }
      const res = await
      this.$http.post(`${process.env.VUE_APP_API}/myLook/checkTelAndLogin`,
        { tel: this.phone, loginId: this.loginId, nickName: this.nickName });
      this.isShowLoading = false;
      // eslint-disable-next-line eqeqeq
      if (res != undefined && res.code != undefined) {
        // eslint-disable-next-line eqeqeq
        if (res.code != 1) {
          this.$toast(res.msg);
        } else {
          this.isShowDialog = true;
        }
      }
    },
    playerStateChanged(state) {
      // eslint-disable-next-line eqeqeq,no-underscore-dangle
      if (this._isMobile()) {
        // eslint-disable-next-line eqeqeq,no-lonely-if
        if (state.ended != undefined && state.ended == true) {
          this.srcIndex += 1;
          // eslint-disable-next-line eqeqeq
          if (this.srcIndex == this.srcList.length) {
            this.srcIndex = 0;
          }
          this.playerOptions.src = this.srcList[this.srcIndex];
          // console.log(this.playerOptions.src);
          this.$refs.videoPlayer.player.src(this.playerOptions.src);
          this.$refs.videoPlayer.player.play();
        }
      }
    },
    // eslint-disable-next-line no-underscore-dangle
    _isMobile() {
      const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    },
    // eslint-disable-next-line no-underscore-dangle
    _isIOS() {
      const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad)/i);
      return flag;
    },

  },
  components: {
    // eslint-disable-next-line vue/no-unused-components
    videoPlayer,
  },

};
</script>

<style lang="scss">

  #app {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
  }

  .bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
  }

  .content {
    position: absolute;
    bottom: 0;
    z-index: 2;
    width: 100%;
    height: 80%;
    background-color: rgba(244, 244, 244, 0.6);
    border-radius: 20px 20px 0 0;
    border-width: 1px;
    border-color: white;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;


    &-h2 {
      flex: 1;
      margin-top: 20px;
      color: #444444;
    }

    &-textfield {
      flex: 2;
      margin: 45px 10px 80px 10px;

      &-one {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
      }
      &-two {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        margin-top: 10px;
      }

      &-i {
        margin: 10px 10px;
        color: #444444;
      }

      &-field {

      }
    }

    &-commit {
      flex: 3;

      &-btn {
        width: 100px;
      }
    }
  }

  .loading {
    position: absolute;
    z-index: 999;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .van-cell {
    background-color: rgba(255, 255, 255, 0.4) !important;
    border-radius: 8px !important;
  }

  /*.van-cell__value {*/
  /*  background-color: rgba(240, 240, 240, 0.6) !important;*/
  /*}*/

  /*.van-field__control {*/
  /*  background-color: rgba(240, 240, 240, 0.6) !important;*/
  /*}*/

</style>
